module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_qr_hand-370664547a4053fdbf3ca96b9027cfea.png";